/** Buyer loan hub + setup; lives under `/loan` with secondary nav in the header. */
export const LOAN_PATH = {
  hub: '/loan',
  loanType: '/loan/loan-type',
  qualifications: '/loan/qualifications',
  /** Anchor of the qualifications section on the Loan type page. */
  qualificationsSection: 'qualifications',
  personalFinancialStatement: '/loan/personal-financial-statement',
  /** Old tab path; redirects to the Loan status section of My applications. */
  loanStatus: '/loan/loan-status',
  /** Anchor of the Loan status section on My applications. */
  loanStatusSection: 'loan-status',
  /** Mortgage documents live on the Documents page (/loan/documents redirects). */
  documents: '/documents',
} as const;

export const LOAN_TAB_ITEMS: ReadonlyArray<{
  label: string;
  path: string;
  tabId: string;
}> = [
  // Loan type and qualifications share one page; /loan/qualifications
  // redirects to its qualifications section.
  { label: 'Loan type', path: LOAN_PATH.loanType, tabId: 'loan-tab-0' },
  // Loan status is a section of My applications; documents are on /documents.
  { label: 'My applications', path: LOAN_PATH.hub, tabId: 'loan-tab-2' },
];

export function isLoanFlowPath(pathname: string): boolean {
  return pathname === '/loan' || pathname.startsWith('/loan/');
}
